import { generarTituloProducto } from './formatters';
import { labelCajaTipo } from '../constants';

const fold = (value) => {
  let text = String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ' ')
    .replace(/[×]/g, 'x');

  while (/(\d)[x*×-](\d)/.test(text)) {
    text = text.replace(/(\d)[x*×-](\d)/g, '$1 $2');
  }

  return text
    .replace(/\bx\b/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
};

const haystackDeProducto = (producto) => {
  if (!producto) return '';
  const extra =
    producto.categoria === 'fundas' || !producto.categoria
      ? 'caja cajas corrugado corrugada'
      : producto.categoria === 'vidrios'
        ? 'autoarmable autoarmables'
        : producto.categoria === 'accesorios'
          ? 'embalaje insumo insumos'
          : '';

  return fold(
    [
      generarTituloProducto(producto),
      producto.nombre,
      producto.modelo,
      producto.material,
      labelCajaTipo(producto.material),
      producto.color,
      producto.cataccesorios,
      producto.categoria,
      extra,
      producto.descripcion,
      producto.ancho,
      producto.alto,
      producto.profundidad,
    ]
      .filter((value) => value != null && value !== '')
      .join(' ')
  );
};

const puntuar = (producto, tokens, queryFolded) => {
  const titulo = fold(generarTituloProducto(producto));
  const modelo = fold(producto.modelo);
  const haystack = haystackDeProducto(producto);

  if (titulo === queryFolded) return 100;
  if (titulo.startsWith(queryFolded)) return 90;
  if (modelo === queryFolded) return 85;

  const todosEnTitulo = tokens.every((token) => titulo.includes(token));
  if (todosEnTitulo) return 75;

  const todosEnModelo = tokens.every((token) => modelo.includes(token));
  if (todosEnModelo) return 70;

  if (tokens.every((token) => haystack.includes(token))) return 50;
  return 0;
};

export const buscarProductos = (productos, query, { limite = 8 } = {}) => {
  const queryFolded = fold(query);
  if (!queryFolded) return [];

  const tokens = queryFolded
    .split(/\s+/)
    .filter((token) => token && token !== 'cm' && token !== 'mm' && (token.length > 1 || /^\d+$/.test(token)));
  if (tokens.length === 0) return [];

  return (productos || [])
    .map((producto) => ({ producto, score: puntuar(producto, tokens, queryFolded) }))
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score || generarTituloProducto(a.producto).localeCompare(generarTituloProducto(b.producto), 'es'))
    .slice(0, limite)
    .map((item) => item.producto);
};

export const mejorResultadoBusqueda = (productos, query) => {
  const resultados = buscarProductos(productos, query, { limite: 1 });
  return resultados[0] || null;
};
